import React from "react";
import { Link, withRouter } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { COLLAPSED_DRAWER, FIXED_DRAWER } from "constants/ActionTypes";
import { toggleCollapsedNav } from "actions/Setting";
import BBLogo from "../../../../assets/images/logo-black.svg"
import BBIconQuestionHandRequest from "../../../../assets/bbCustomIcons/BBIconQuestionHandRequest";
import LaunchTourIconButton from "../../../ProductTours/LaunchTourIconButton";
import SearchEntities from "../../../../components/customBreachBits/SearchEntities";

const Index =(props)=> {

  const dispatch = useDispatch();
  const { drawerType, navCollapsed } = useSelector(({settings}) => settings);

  const {tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade} = useSelector(({auth}) => auth);
  // console.log("tokenOfAdminDuringMasquerade", tokenOfAdminDuringMasquerade, "refreshTokenOfAdminDuringMasquerade", refreshTokenOfAdminDuringMasquerade)
  // const [langSwitcher,setLangSwitcher]=useState(false);
  // const [mailNotification,setMailNotification]=useState(false);
  // const [appNotification,setAppNotification]=useState(false);
  // const [searchBox,setSearchBox]=useState(false);
  // const [apps,setApps]=useState(false);
  // const [searchText,setSearchText]=useState('');

  // const onAppNotificationSelect = () => {
  //   setAppNotification(!appNotification)
  // };
  //
  // const onMailNotificationSelect = () => {
  //   setMailNotification(!mailNotification)
  // };
  // const onLangSwitcherSelect = (event) => {
  //   setLangSwitcher(!langSwitcher);
  // };
  //
  // const onSearchBoxSelect = () => {
  //   setSearchBox(!searchBox)
  // };
  // const onAppsSelect = () => {
  //   setApps(!apps)
  // };

  // const handleRequestClose = () => {
  //   setSearchBox(false);
  //   setLangSwitcher(false);
  //   setMailNotification(false);
  //   setSearchBox(false);
  //   setApps(false);
  // };

  // const handleMasqueradeQuit = () => {
  //   dispatch(masqueradeQuit(tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade))
  // }

  const onToggleCollapsedNav = (e) => {
    const val = !navCollapsed;
    dispatch(toggleCollapsedNav(val));
  };


  // const Apps = () => {
  //   return (
  //     <ul className="jr-list jr-list-half">
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/app/calendar/basic">
  //           <i className="zmdi zmdi-calendar zmdi-hc-fw"/>
  //           <span className="jr-list-text"><IntlMessages id="sidebar.calendar.basic"/></span>
  //         </Link>
  //       </li>
  //
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/app/to-do">
  //           <i className="zmdi zmdi-check-square zmdi-hc-fw"/>
  //           <span className="jr-list-text"><IntlMessages id="sidebar.appModule.toDo"/></span>
  //         </Link>
  //       </li>
  //
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/app/mail">
  //           <i className="zmdi zmdi-email zmdi-hc-fw"/>
  //           <span className="jr-list-text"><IntlMessages id="sidebar.appModule.mail"/></span>
  //         </Link>
  //       </li>
  //
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/app/chat">
  //           <i className="zmdi zmdi-comment zmdi-hc-fw"/>
  //           <span className="jr-list-text"><IntlMessages id="sidebar.appModule.chat"/></span>
  //         </Link>
  //       </li>
  //
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/app/contact">
  //           <i className="zmdi zmdi-account-box zmdi-hc-fw"/>
  //           <span className="jr-list-text"><IntlMessages id="sidebar.appModule.contact"/></span>
  //         </Link>
  //       </li>
  //
  //       <li className="jr-list-item">
  //         <Link className="jr-list-link" to="/">
  //           <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"/>
  //           <span className="jr-list-text">Add New</span>
  //         </Link>
  //       </li>
  //     </ul>);
  // };


    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-block d-xl-none" : drawerType.includes(COLLAPSED_DRAWER) ? "d-block" : "d-none";

    return (
      <AppBar id={"appBarNavBar"} className="app-main-header">
        <Toolbar className="app-toolbar" disableGutters={false}>

          <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                      onClick={onToggleCollapsedNav}>
            <span className="menu-icon"/>
          </IconButton>

          <Link className="app-logo mr-2 d-sm-block" to="/">
            <div style={{
              backgroundImage: `url(${BBLogo})`,
              marginTop: "6px",
              width: "280px",
              backgroundRepeat: "no-repeat",
              height: "50px"
            }}><></>
            </div>
          </Link>

          {/*<SearchEntities styleName="d-flex app-toolbar align-items-center"/>*/}

          <div className="ellipse-shape"/>
          <div className="ellipse-shape2"/>
          <div className="ellipse-shape3"/>

          <div style={{
            marginTop: "7px",
            marginLeft: "250px",
            width: "1300px",
            height: "60px",
            overflow: "clip"

          }}>
            <h1 style={{
              color: "#DAD9D9",
              fontSize: "14pt"
            }}>The world's <strong>most accurate</strong><br/> cyber risk rating platform.™</h1>
            {/*<h1 style={{*/}
            {/*  color: "#DAD9D9",*/}
            {/*  fontSize: "14pt",*/}
            {/*  lineHeight: "22pt",*/}
            {/*}}>The world's <strong><span style={{*/}
            {/*  backgroundColor: "#DBEB2E",*/}
            {/*  color: "#4B4C4C"*/}
            {/*}}>&nbsp;most accurate&nbsp;&nbsp;</span></strong><br/> cyber risk rating*/}
            {/*  platform.™</h1>*/}
          </div>

          <div className={""} style={{width: "100%"}}><LaunchTourIconButton
              className={" float-right animated animation-duration-40 pulse pulse-slow"}/></div>
        </Toolbar>
      </AppBar>
    );
};


export default withRouter(Index);
